import { useState } from "react";

const useConfirmation = (renderFn) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<{ actions?: any }>({});
  // CN-2798: choices the prompt itself collects (the "Notify athlete" switch).
  // Kept here, not in the prompt: PromptComponent is a new component on every
  // render, so state inside it would reset whenever the page re-renders.
  const [options, setOptions] = useState<{ notifyStudents: boolean }>({ notifyStudents: true });

  const requestConfirmation = (payload) => {
    setData(payload);
    setOptions({ notifyStudents: true });
    setShowPrompt(true);
  };

  const onCancel = () => {
    setShowPrompt(false);
    setData({});
    setLoading(false);
  };

  const decoratedActions = {};
  if (data.actions) {
    Object.keys(data.actions).forEach(actionName => {
      decoratedActions[actionName] = async () => {
        setLoading(true);
        try {
          await data.actions[actionName](data, options);
        } finally {
          onCancel();
        }
      };
    });
  }


  const PromptComponent = () => {
    if(!showPrompt) {
      return null;
    }

    return renderFn({ data, loading, options, setOptions, actions: { onCancel, ...decoratedActions } });
  };

  return { requestConfirmation, PromptComponent };
};

export default useConfirmation;
